import React from 'react';
import styled from 'styled-components';
import illustrasiKanggo from '../../../assets/img/illustrasi-kanggo-warning.png';
import Dialog from '../../../components/Dialog';
import { Button } from '../../../components/Styled';

const DeleteImageWrapper = styled.div`
    position: relative;
    display: block;
    height: 140px;
    text-align: center;

    img {
        height: 100%;
    }
`;

interface IDialogDeleteMember {
    member?: any,
    many?: boolean,
    onDeleteConfirm: () => void,
    // eslint-disable-next-line no-unused-vars
    dialogHandler: (showDialog: boolean) => void
}

const DialogDeleteMember: React.FC<IDialogDeleteMember> = (props) => {
    const { member, many, onDeleteConfirm, dialogHandler } = props;

    const onConfirm = () => {
        onDeleteConfirm();
        dialogHandler(false);
    };

    return (
        <Dialog noWrap>
            <DeleteImageWrapper>
                <img src={illustrasiKanggo} alt="PT. Tenaga Kanggo Indonesia" />
            </DeleteImageWrapper>
            <p className="font-bold text-center my-3">{`Kamu yakin hapus ${many ? 'anggota yang dipilih?' : member.name}`}</p>
            <p className="text-center mb-3">Data yang dihapus tidak dapat dikembalikan lagi.</p>
            <div className="row">
                <div className="col-6">
                    <Button block rounded gradient onClick={() => dialogHandler(false)}>Batalkan</Button>
                </div>
                <div className="col-6">
                    <Button block border rounded textBlack primary onClick={() => onConfirm()}>Hapus</Button>
                </div>
            </div>
        </Dialog>
    );
};

DialogDeleteMember.defaultProps = {
    member: {},
    many: false
};

export default DialogDeleteMember;
